import store from '../store/index'
export const gridUtils = {
  data () {
    return {
      // example: for the last element [4, 3] it means that we have 7 elements on Dashboard arranged on 2 rows, 4 elements on first row and 3 on the second
      rowLayout: [
        [0],
        [1],
        [1, 1], // 2 elem
        [2, 1], // 3 elem
        [2, 2],
        [3, 2],
        [4, 2],
        [4, 3],
        [4, 4]
      ],
      cssClassPerRow: [
        [''],
        ['col-md-12'],
        ['col-md-12', 'col-md-12'],
        ['col-md-6', 'col-md-12'],
        ['col-md-6', 'col-md-6'],
        ['col-md-4', 'col-md-6'],
        ['col-md-3', 'col-md-6'],
        ['col-md-3', 'col-md-4'],
        ['col-md-3', 'col-md-3']
      ],
      routesArray: [],
      fieldsEn: {
        dashboard: 'Dashboard',
        dependents: 'Dependents',
        edit_personal_data: 'Edit personal data',
        register_kit: 'Register kit',
        new_order: 'New Order',
        results: 'Results',
        manage_account: 'Manage your account',
        log_out: 'Log out',
        go_pass: 'Go Pass',
        pay_my_bills: 'Pay My Bills',
        scheduling: 'Scheduling'
      }
    }
  },
  beforeMount () {
    this.routesArray.push(this.dashboardElementsDetailsSmall['editPersonalData'])
    this.routesArray.push(this.dashboardElementsDetailsSmall['dependents'])
    this.routesArray.push(this.dashboardElementsDetailsSmall['account'])
  },
  computed: {
    dashboardElementsDetails () {
      return {
        dependents: {
          isDisabled: (buttonClicked, sitecode, firstRegistration) => { return buttonClicked === true || sitecode === false || firstRegistration === true },
          image: 'dependents',
          route: '/patient/account/dependents',
          buttonText: this.fieldsEn['dependents']
        },
        newOrder: {
          isDisabled: (buttonClicked, sitecode, firstRegistration) => { return buttonClicked === true || sitecode === false || firstRegistration === true },
          image: 'newOrder',
          route: '/patient/account/form/registration',
          buttonText: this.fieldsEn['new_order']
        },
        registerKit: {
          isDisabled: (buttonClicked, sitecode, firstRegistration) => { return buttonClicked === true || sitecode === false || firstRegistration === true },
          image: 'kit',
          route: '/patient/kit',
          buttonText: this.fieldsEn['register_kit']
        },
        results: {
          isDisabled: (buttonClicked, sitecode, firstRegistration) => { return buttonClicked === true || sitecode === false || firstRegistration === true },
          image: 'checkResults',
          route: '/patient/account/results',
          buttonText: this.fieldsEn['results']
        },
        goPass: {
          isDisabled: (buttonClicked, sitecode, firstRegistration) => { return buttonClicked === true || sitecode === false || firstRegistration === true },
          image: 'goPass',
          route: '/patient/account/go-pass',
          buttonText: this.fieldsEn['go_pass']
        },
        payMyBills: {
          isDisabled: (buttonClicked, sitecode, firstRegistration) => { return buttonClicked === true || sitecode === false || firstRegistration === true },
          image: 'payMyBills',
          route: '/patient/account/pay-my-bills',
          buttonText: this.fieldsEn['pay_my_bills']
        },
        schedule: {
          isDisabled: (buttonClicked, sitecode, firstRegistration) => { return buttonClicked === true || sitecode === false || firstRegistration === true },
          image: 'schedule',
          route: '/patient/account/schedule',
          buttonText: this.fieldsEn['scheduling']
        }
      }
    },
    dashboardElementsDetailsSmall () {
      return {
        dependents: {
          isDisabled: (buttonClicked, sitecode, firstRegistration) => { return buttonClicked === true || sitecode === false || firstRegistration === true },
          image: 'dependents',
          route: '/patient/account/dependents',
          buttonText: this.fieldsEn['dependents']
        },
        editPersonalData: {
          isDisabled: (buttonClicked) => { return buttonClicked === true },
          image: 'personalData',
          route: '/patient/account/data',
          buttonText: this.fieldsEn['edit_personal_data']
        },
        account: {
          isDisabled: (buttonClicked) => { return buttonClicked === true },
          image: 'manageAccount',
          route: '/patient/account/manage',
          buttonText: this.fieldsEn['manage_account']
        }
      }
    }
  },
  methods: {
    // calculate how the elements will appear (what class to take from cssClassPerRow)
    calculatePositionOnGrid (index) {
      let i
      this.rowLayout[store.state.dashboardElements.length].every((element, idx) => {
        if (index > element) {
          index = index - element
          return true
        } else {
          i = idx
          return false
        }
      })
      return this.cssClassPerRow[store.state.dashboardElements.length][i]
    }
  }
}




// WEBPACK FOOTER //
// ./src/utils/DashboardGrid.js